


















import { Vue, Component, Prop } from 'vue-property-decorator'
import translate from '@/language'

@Component
export default class Input extends Vue {
  @Prop({ required: true, type: String }) readonly value!: string
  @Prop({ type: String, default: 'text' }) readonly type!: string
  @Prop({ type: String, default: '' }) readonly error?: string
  @Prop({ type: String, default: '' }) readonly name?: string
  @Prop({ type: String, default: '' }) readonly id?: string
  @Prop({ type: String, default: '' }) readonly autocomplete?: string
  @Prop({ type: Boolean, default: false }) readonly hiddenField?: boolean
  @Prop({ type: Boolean, default: false }) readonly disabled?: boolean
  @Prop({ type: Number }) readonly maxLength?: number

  visibility = false

  get inputType(): string {
    if (!this.hiddenField) return this.type
    return this.visibility ? 'text' : 'password'
  }
  get visiblityLabel(): string {
    return this.visibility ? translate('', 'input-hide') : translate('', 'input-show')
  }

  toggleVisiblity(): void {
    this.visibility = !this.visibility
  }
}
